export default "__VITE_ASSET__BD3Qg7SB__"